import { PREMIUM_FEATURES } from "@common/flatRateBilling";
import { useAllowFeature } from "./useAllowFeature";

export function useCanUseInvoicing(): boolean {
    const { hasAccess, isFetched } = useAllowFeature(PREMIUM_FEATURES.INVOICES);

    return !isFetched || hasAccess;
}
